import {FC} from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useModule} from '../../../platform/modules'

const Error403: FC = () => {
  const {defaultRoute} = useModule()

  return (
    <main className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid p-10 text-center'>
        <img
          src={toAbsoluteUrl('/media/illustrations/sketchy-1/18.png')}
          alt=''
          className='mw-100 mb-8 h-lg-350px'
        />
        <p className='text-primary fw-bold fs-6 mb-3'>403</p>
        <h1 className='fw-bold text-dark mb-4'>Bu çalışma alanına erişiminiz yok</h1>
        <p className='text-muted mw-550px mb-8'>
          Sayfa seçili modüle ait olsa da aktif rolünüz için gerekli menü veya işlem yetkisi tanımlı
          değil.
        </p>
        <Link to={defaultRoute} className='btn btn-primary'>
          Modül genel bakışına dön
        </Link>
      </div>
    </main>
  )
}

export {Error403}
